module.exports = __webpack_public_path__ + "media/images/flags/32/Colombia-5ed5e1f2c83a643b691470b9f5d825ad.png";